export { default } from "./personalInfo";
